/**
 * Defines a GroupInviteRequest model. This is used to requesting to join a group
 * that is private.
 */
import Backbone from 'backbone';

var GroupInviteMemberRequest = Backbone.Model.extend({
    idAttribute: 'groupMemberRequestId',

    url: function() {
        return '/group-service/private/group/' + this.userGroupId;
    },

    backend: 'gcapi',

    initialize: function(args) {
        this.userGroupId = args.userGroupId;
        this.groupMemberRequestId = args.groupMemberRequestId;
    }
});

export default GroupInviteMemberRequest;
